export default "__VITE_ASSET__CPaeww2P__"